import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'mailup-web-components'
import {
  fromUTCtoZoneFormatted,
  getLang,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'

const Date = ({ date }) => {
  const lang = getLang()
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const dateSplit = fromUTCtoZoneFormatted(
    date,
    TimeZoneCode,
    'YYYY-MM-DD ddd HH:mm UTCZ',
    lang
  ).split(' ')
  return (
    <>
      <Text variant='light'>
        {dateSplit[0] + ' ' + dateSplit[1] + ' ' + dateSplit[2]}
      </Text>
    </>
  )
}

export default Date

Date.propTypes = {
  date: PropTypes.string
}
